import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Accordion from 'react-bootstrap/Accordion';
import { FaqsList } from '../../projectData/Data'


const QuestionCard = () => {
    const { t, i18n } = useTranslation();
    const [activeKey, setActiveKey] = useState(null);

    return (
        <Accordion defaultActiveKey="0" flush activeKey={activeKey} onSelect={(key) => setActiveKey(key)}>
            {FaqsList.map((item, key) => (
                <Accordion.Item eventKey={key.toString()} key={key} className={activeKey === key.toString() ? "active-item" : ""}>
                    <Accordion.Header>{t(item.question)}</Accordion.Header>
                    <Accordion.Body>
                        
                            {t(item.answer)}
                        
                    </Accordion.Body>
                </Accordion.Item>
            ))}
        </Accordion>
        
    )
}

export default QuestionCard